(function ($) {
  $.fn.initForm = function () {
    var $that = $(this),
        id = $that.data('id'),
        solution_id = $that.data('solution-id'),
        language = $that.data('language');

    esw.forms.create({
      "solutionId": solution_id,
      "formId": id,
      "language": language,
      "buildinelement": null
    });
  };
}(jQuery));

$(function () {
  if ($('.js-easywebform').length) {
    $('.js-easywebform').initForm();
  }
});